// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/invoices.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CardCheckResultEnum, DiscountTypeEnum, DisputeStatusEnum, EventTypeEnum, InvoiceStatusEnum, ItemKindEnum, ItemUnitEnum, ManualPaymentMethodEnum, PaymentIntentStatusEnum, PaymentNetworkStatusEnum, PaymentOutcomeTypeEnum, PaymentRiskLevelEnum, PaymentScheduleStatusEnum, PaymentStatusEnum, PortalAttributionModeEnum, QuotePaymentScheduleAmountTypeEnum, QuotePaymentScheduleDueDateAnchorEnum, QuoteRejectionReasonEnum, QuoteStatusEnum, StripeCheckoutPaymentMethodEnum, StripePaymentStatusEnum, TipAllocationModeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/invoices.proto.
 */
export const file_cortado_v1_invoices: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_settings, file_cortado_v1_users, file_google_protobuf_timestamp]);

/**
 * QuoteEvent represents an event associated with a quote revision
 * Captures event dates/times for the quote, which determine booking events on acceptance
 * Fields are aligned with Event for seamless quote-to-booking conversion
 *
 * @generated from message cortado.v1.QuoteEvent
 */
export type QuoteEvent = Message<"cortado.v1.QuoteEvent"> & {
  /**
   * Unique identifier for the quote event
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the quote event belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Quote revision ID this event belongs to
   *
   * @generated from field: string quote_revision_id = 3;
   */
  quoteRevisionId: string;

  /**
   * Date of the event (optional - may not be set initially)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 4;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional) - aligned with Event.event_length
   *
   * @generated from field: optional double event_length = 5;
   */
  eventLength?: number;

  /**
   * Number of guests (optional) - aligned with Event.event_guests
   *
   * @generated from field: optional int32 event_guests = 6;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional) - aligned with Event.event_timezone
   *
   * @generated from field: optional string event_timezone = 7;
   */
  eventTimezone?: string;

  /**
   * Location of the event (optional) - aligned with Event.event_location
   *
   * @generated from field: optional string event_location = 8;
   */
  eventLocation?: string;

  /**
   * Number of baristas (optional) - aligned with Event.barista_count
   *
   * @generated from field: optional int32 barista_count = 9;
   */
  baristaCount?: number;

  /**
   * Number of carts (optional) - aligned with Event.cart_count
   *
   * @generated from field: optional int32 cart_count = 10;
   */
  cartCount?: number;

  /**
   * Inquiry (request) event this quote event was copied from, when known.
   * A soft reference: the inquiry event may since have been edited or removed.
   *
   * @generated from field: optional string source_inquiry_event_id = 11;
   */
  sourceInquiryEventId?: string;
};

/**
 * Describes the message cortado.v1.QuoteEvent.
 * Use `create(QuoteEventSchema)` to create a new message.
 */
export const QuoteEventSchema: GenMessage<QuoteEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 0);

/**
 * Quote represents a quote with current revision data denormalized
 *
 * @generated from message cortado.v1.Quote
 */
export type Quote = Message<"cortado.v1.Quote"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * @generated from field: string contact_id = 4;
   */
  contactId: string;

  /**
   * @generated from field: int32 quote_number = 5;
   */
  quoteNumber: number;

  /**
   * Revision tracking
   *
   * @generated from field: string current_revision_id = 6;
   */
  currentRevisionId: string;

  /**
   * @generated from field: optional string accepted_revision_id = 7;
   */
  acceptedRevisionId?: string;

  /**
   * Current revision data (denormalized from current_revision)
   *
   * @generated from field: string title = 10;
   */
  title: string;

  /**
   * @generated from field: optional string description = 11;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 12;
   */
  validUntil?: Timestamp;

  /**
   * @generated from field: int64 subtotal_cents = 13;
   */
  subtotalCents: bigint;

  /**
   * Now calculated as SUM of line item taxes
   *
   * @generated from field: int64 sales_tax_cents = 15;
   */
  salesTaxCents: bigint;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 16;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 17;
   */
  discountValue?: number;

  /**
   * @generated from field: int64 discount_cents = 18;
   */
  discountCents: bigint;

  /**
   * @generated from field: optional int64 enforced_tip_cents = 19;
   */
  enforcedTipCents?: bigint;

  /**
   * @generated from field: optional bool enforced_tip_enabled = 26;
   */
  enforcedTipEnabled?: boolean;

  /**
   * @generated from field: optional double enforced_tip_percentage = 27;
   */
  enforcedTipPercentage?: number;

  /**
   * Excludes tip
   *
   * @generated from field: int64 total_cents = 20;
   */
  totalCents: bigint;

  /**
   * total_cents plus enforced_tip_cents: the amount the customer pays at checkout.
   *
   * @generated from field: int64 total_with_tip_cents = 87;
   */
  totalWithTipCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.QuoteLineItem line_items = 21;
   */
  lineItems: QuoteLineItem[];

  /**
   * Discount denormalization (added for reporting/grouping)
   *
   * @generated from field: optional string discount_id = 24;
   */
  discountId?: string;

  /**
   * @generated from field: optional string discount_name = 25;
   */
  discountName?: string;

  /**
   * Status and tracking
   *
   * @generated from field: cortado.v1.QuoteStatusEnum status = 30;
   */
  status: QuoteStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 31;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp viewed_at = 32;
   */
  viewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp accepted_at = 33;
   */
  acceptedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp rejected_at = 84;
   */
  rejectedAt?: Timestamp;

  /**
   * @generated from field: cortado.v1.QuoteRejectionReasonEnum rejection_reason_category = 85;
   */
  rejectionReasonCategory: QuoteRejectionReasonEnum;

  /**
   * @generated from field: optional string rejection_reason = 86;
   */
  rejectionReason?: string;

  /**
   * Event details (denormalized from current revision) - LEGACY single event fields
   * Use quote_events for multi-event support; these are kept for backward compatibility
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 34;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 35;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 guest_count = 36;
   */
  guestCount?: number;

  /**
   * in hours
   *
   * @generated from field: optional double event_duration = 37;
   */
  eventDuration?: number;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 42;
   */
  updatedBy: string;

  /**
   * Payment schedules (denormalized from current revision)
   *
   * @generated from field: repeated cortado.v1.QuotePaymentSchedule payment_schedules = 50;
   */
  paymentSchedules: QuotePaymentSchedule[];

  /**
   * Embedded objects (optional enrichment)
   *
   * @generated from field: optional cortado.v1.User updated_by_user = 51;
   */
  updatedByUser?: User;

  /**
   * Quote events (multiple events per quote revision)
   * These determine the booking events when the quote is accepted
   *
   * @generated from field: repeated cortado.v1.QuoteEvent quote_events = 71;
   */
  quoteEvents: QuoteEvent[];

  /**
   * Payment method override for checkout (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 80;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Add-on offers available to the customer on this quote revision
   *
   * @generated from field: repeated cortado.v1.QuoteAddonOffer addon_offers = 81;
   */
  addonOffers: QuoteAddonOffer[];

  /**
   * Whether accepting this quote attaches a questionnaire to the booking.
   * Copied from the lead at quote creation and overridable per quote.
   * Metadata only - changing it does NOT create a new revision.
   *
   * @generated from field: bool requires_questionnaire = 82;
   */
  requiresQuestionnaire: boolean;

  /**
   * @generated from field: optional string job_id = 83;
   */
  jobId?: string;

  /**
   * How the enforced tip is spread across payment schedules
   *
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 88;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.Quote.
 * Use `create(QuoteSchema)` to create a new message.
 */
export const QuoteSchema: GenMessage<Quote> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 1);

/**
 * QuoteAddonOffer represents an optional catalog item offered to the
 * customer on a quote revision. Offers are snapshotted per-revision; the
 * customer's selections become QuoteLineItems with source_addon_offer_id set.
 *
 * @generated from message cortado.v1.QuoteAddonOffer
 */
export type QuoteAddonOffer = Message<"cortado.v1.QuoteAddonOffer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_revision_id = 2;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: optional string source_item_id = 3;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 6;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: string unit = 8;
   */
  unit: string;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * Per-offer tax fields
   *
   * @generated from field: bool is_taxable = 11;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 12;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 13;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 14;
   */
  salesTaxRate?: number;

  /**
   * Quantity authored by the tenant in the quote builder. The customer can
   * only opt the add-on in or out; they cannot change this quantity.
   *
   * @generated from field: double quantity = 15;
   */
  quantity: number;

  /**
   * Server-computed total (unit_price_cents x quantity, rounded the same way
   * as the resulting line item). Never trust a client-side recomputation of
   * this value.
   *
   * @generated from field: int64 total_cents = 16;
   */
  totalCents: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.QuoteAddonOffer.
 * Use `create(QuoteAddonOfferSchema)` to create a new message.
 */
export const QuoteAddonOfferSchema: GenMessage<QuoteAddonOffer> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 2);

/**
 * QuoteAddonOfferInput represents input data for creating a quote add-on offer
 * Supports two modes:
 * 1. Catalog item: Provide item_id, backend fetches item details
 * 2. Custom offer: Provide name, unit, unit_price_cents directly
 *
 * @generated from message cortado.v1.QuoteAddonOfferInput
 */
export type QuoteAddonOfferInput = Message<"cortado.v1.QuoteAddonOfferInput"> & {
  /**
   * Optional - present when editing an existing offer
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Optional - for catalog-seeded offers
   *
   * @generated from field: optional string item_id = 2;
   */
  itemId?: string;

  /**
   * Optional - required for custom offers
   *
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * Optional - overrides catalog item price OR required for custom offers
   *
   * @generated from field: optional int64 unit_price_cents = 5;
   */
  unitPriceCents?: bigint;

  /**
   * Optional - required for custom offers (default: "Per Event")
   *
   * @generated from field: optional string unit = 6;
   */
  unit?: string;

  /**
   * @generated from field: optional int32 sort_order = 7;
   */
  sortOrder?: number;

  /**
   * Per-offer tax fields
   *
   * @generated from field: bool is_taxable = 8;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 9;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 10;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 11;
   */
  salesTaxRate?: number;

  /**
   * Optional - defaults to 1 when omitted
   *
   * @generated from field: optional double quantity = 12;
   */
  quantity?: number;
};

/**
 * Describes the message cortado.v1.QuoteAddonOfferInput.
 * Use `create(QuoteAddonOfferInputSchema)` to create a new message.
 */
export const QuoteAddonOfferInputSchema: GenMessage<QuoteAddonOfferInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 3);

/**
 * QuoteLineItemInput represents input data for creating a quote line item
 * Supports two modes:
 * 1. Catalog item: Provide item_id, backend fetches item details
 * 2. Custom item: Provide name, unit, unit_price_cents directly (one-time use)
 *
 * @generated from message cortado.v1.QuoteLineItemInput
 */
export type QuoteLineItemInput = Message<"cortado.v1.QuoteLineItemInput"> & {
  /**
   * Optional - for catalog items
   *
   * @generated from field: optional string item_id = 1;
   */
  itemId?: string;

  /**
   * Required - quantity of item (supports fractional quantities like 2.5 hours)
   *
   * @generated from field: double quantity = 2;
   */
  quantity: number;

  /**
   * Optional - overrides catalog item price OR required for custom items
   *
   * @generated from field: optional int64 unit_price_cents = 3;
   */
  unitPriceCents?: bigint;

  /**
   * Optional - required for custom items (one-time use)
   *
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * Optional - for custom items
   *
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * Optional - required for custom items (default: "Per Event")
   *
   * @generated from field: optional string unit = 6;
   */
  unit?: string;

  /**
   * Per-line-item tax fields
   *
   * Required - whether this line item is taxable (default: true)
   *
   * @generated from field: bool is_taxable = 7;
   */
  isTaxable: boolean;

  /**
   * Optional - UUID reference to tax_rates table
   *
   * @generated from field: optional string sales_tax_rate_id = 8;
   */
  salesTaxRateId?: string;

  /**
   * Optional - denormalized tax rate name
   *
   * @generated from field: optional string sales_tax_rate_name = 9;
   */
  salesTaxRateName?: string;

  /**
   * Optional - tax rate as decimal (e.g., 0.0825 for 8.25%)
   *
   * @generated from field: optional double sales_tax_rate = 10;
   */
  salesTaxRate?: number;

  /**
   * Required - pre-calculated tax amount in cents
   *
   * @generated from field: int64 sales_tax_cents = 11;
   */
  salesTaxCents: bigint;

  /**
   * @generated from field: optional string quote_revision_event_id = 12;
   */
  quoteRevisionEventId?: string;
};

/**
 * Describes the message cortado.v1.QuoteLineItemInput.
 * Use `create(QuoteLineItemInputSchema)` to create a new message.
 */
export const QuoteLineItemInputSchema: GenMessage<QuoteLineItemInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 4);

/**
 * QuoteLite is a lightweight quote representation for list views
 *
 * @generated from message cortado.v1.QuoteLite
 */
export type QuoteLite = Message<"cortado.v1.QuoteLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * @generated from field: string contact_id = 4;
   */
  contactId: string;

  /**
   * @generated from field: int32 quote_number = 5;
   */
  quoteNumber: number;

  /**
   * Summary fields
   *
   * @generated from field: optional string title = 10;
   */
  title?: string;

  /**
   * @generated from field: optional string contact_name = 11;
   */
  contactName?: string;

  /**
   * Excludes tip
   *
   * @generated from field: int64 total_cents = 12;
   */
  totalCents: bigint;

  /**
   * total_cents plus the revision's enforced tip.
   *
   * @generated from field: int64 total_with_tip_cents = 26;
   */
  totalWithTipCents: bigint;

  /**
   * @generated from field: cortado.v1.QuoteStatusEnum status = 13;
   */
  status: QuoteStatusEnum;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp sent_at = 20;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 21;
   */
  validUntil?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */
  createdAt?: Timestamp;

  /**
   * Event dates across the quote's quote_events rows, ordered ascending (earliest first).
   * Clients can treat index 0 as the primary display date and the remainder as "+N more".
   *
   * @generated from field: repeated google.protobuf.Timestamp event_dates = 23;
   */
  eventDates: Timestamp[];

  /**
   * Whether accepting this quote attaches a questionnaire to the booking.
   *
   * @generated from field: bool requires_questionnaire = 24;
   */
  requiresQuestionnaire: boolean;

  /**
   * @generated from field: optional string job_id = 25;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.QuoteLite.
 * Use `create(QuoteLiteSchema)` to create a new message.
 */
export const QuoteLiteSchema: GenMessage<QuoteLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 5);

/**
 * ContactQuoteInteraction represents public quote token activity attributed to a contact
 *
 * @generated from message cortado.v1.ContactQuoteInteraction
 */
export type ContactQuoteInteraction = Message<"cortado.v1.ContactQuoteInteraction"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string quote_id = 3;
   */
  quoteId: string;

  /**
   * @generated from field: optional string inquiry_id = 4;
   */
  inquiryId?: string;

  /**
   * @generated from field: optional string booking_id = 5;
   */
  bookingId?: string;

  /**
   * Recipient attribution
   *
   * @generated from field: optional string recipient_contact_id = 10;
   */
  recipientContactId?: string;

  /**
   * @generated from field: string recipient_email = 20;
   */
  recipientEmail: string;

  /**
   * Quote display fields
   *
   * @generated from field: int32 quote_number = 30;
   */
  quoteNumber: number;

  /**
   * @generated from field: optional string quote_title = 31;
   */
  quoteTitle?: string;

  /**
   * @generated from field: cortado.v1.QuoteStatusEnum quote_status = 32;
   */
  quoteStatus: QuoteStatusEnum;

  /**
   * Public interaction state
   *
   * @generated from field: int32 view_count = 40;
   */
  viewCount: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_viewed_at = 41;
   */
  firstViewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_viewed_at = 42;
   */
  lastViewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp accepted_at = 43;
   */
  acceptedAt?: Timestamp;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.ContactQuoteInteraction.
 * Use `create(ContactQuoteInteractionSchema)` to create a new message.
 */
export const ContactQuoteInteractionSchema: GenMessage<ContactQuoteInteraction> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 6);

/**
 * QuoteLineItem represents a line item in a quote (from current revision)
 *
 * @generated from message cortado.v1.QuoteLineItem
 */
export type QuoteLineItem = Message<"cortado.v1.QuoteLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_revision_id = 2;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: optional string source_item_id = 3;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 6;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: double quantity = 7;
   */
  quantity: number;

  /**
   * @generated from field: string unit = 8;
   */
  unit: string;

  /**
   * @generated from field: int64 line_total_cents = 9;
   */
  lineTotalCents: bigint;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * Per-line-item tax fields
   *
   * @generated from field: bool is_taxable = 11;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 12;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 13;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 14;
   */
  salesTaxRate?: number;

  /**
   * @generated from field: int64 sales_tax_cents = 15;
   */
  salesTaxCents: bigint;

  /**
   * Presence indicates this line item was added by the customer from a
   * QuoteAddonOffer (rather than authored on the quote by the tenant).
   *
   * @generated from field: optional string source_addon_offer_id = 21;
   */
  sourceAddonOfferId?: string;

  /**
   * Optional enrichment
   *
   * @generated from field: optional cortado.v1.Item source_item = 20;
   */
  sourceItem?: Item;

  /**
   * Images of the source catalog item, cover first. Set on the customer portal
   * mount, where source_item is not sent.
   *
   * @generated from field: repeated cortado.v1.LineItemImage images = 22;
   */
  images: LineItemImage[];
};

/**
 * Describes the message cortado.v1.QuoteLineItem.
 * Use `create(QuoteLineItemSchema)` to create a new message.
 */
export const QuoteLineItemSchema: GenMessage<QuoteLineItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 7);

/**
 * Invoice represents an invoice with current revision data and payment schedules
 * Supports two modes:
 * 1. Quote-based invoice: quote_id and accepted_quote_revision_id are provided (invoice copies from accepted quote)
 * 2. Standalone invoice: quote_id and accepted_quote_revision_id are null (invoice created directly)
 *
 * @generated from message cortado.v1.Invoice
 */
export type Invoice = Message<"cortado.v1.Invoice"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * Optional - null for standalone invoices
   *
   * @generated from field: optional string quote_id = 4;
   */
  quoteId?: string;

  /**
   * Optional - null for standalone invoices
   *
   * @generated from field: optional string accepted_quote_revision_id = 5;
   */
  acceptedQuoteRevisionId?: string;

  /**
   * @generated from field: string contact_id = 6;
   */
  contactId: string;

  /**
   * @generated from field: int32 invoice_number = 7;
   */
  invoiceNumber: number;

  /**
   * Revision tracking
   *
   * @generated from field: string current_revision_id = 10;
   */
  currentRevisionId: string;

  /**
   * @generated from field: optional string locked_revision_id = 11;
   */
  lockedRevisionId?: string;

  /**
   * Current revision data (denormalized from current_revision)
   *
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * @generated from field: int64 subtotal_cents = 22;
   */
  subtotalCents: bigint;

  /**
   * Now calculated as SUM of line item taxes
   *
   * @generated from field: int64 sales_tax_cents = 23;
   */
  salesTaxCents: bigint;

  /**
   * Discount fields (denormalized)
   *
   * Type of discount (PERCENTAGE or FIXED_AMOUNT)
   *
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 16;
   */
  discountType?: DiscountTypeEnum;

  /**
   * Numeric value of the discount
   *
   * @generated from field: optional double discount_value = 17;
   */
  discountValue?: number;

  /**
   * Calculated discount amount in cents
   *
   * @generated from field: int64 discount_cents = 24;
   */
  discountCents: bigint;

  /**
   * UUID reference for reporting
   *
   * @generated from field: optional string discount_id = 36;
   */
  discountId?: string;

  /**
   * Denormalized discount name
   *
   * @generated from field: optional string discount_name = 37;
   */
  discountName?: string;

  /**
   * Tip fields
   *
   * Calculated enforced tip amount in cents
   *
   * @generated from field: optional int64 enforced_tip_cents = 19;
   */
  enforcedTipCents?: bigint;

  /**
   * Total tip amount (enforced + custom)
   *
   * @generated from field: int64 tip_cents = 25;
   */
  tipCents: bigint;

  /**
   * Whether enforced tips are active
   *
   * @generated from field: optional bool enforced_tip_enabled = 38;
   */
  enforcedTipEnabled?: boolean;

  /**
   * Percentage for enforced tips
   *
   * @generated from field: optional double enforced_tip_percentage = 39;
   */
  enforcedTipPercentage?: number;

  /**
   * @generated from field: int64 total_cents = 26;
   */
  totalCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.InvoiceLineItem line_items = 27;
   */
  lineItems: InvoiceLineItem[];

  /**
   * Payment schedules (nested)
   *
   * @generated from field: repeated cortado.v1.PaymentSchedule payment_schedules = 30;
   */
  paymentSchedules: PaymentSchedule[];

  /**
   * Financial summary (calculated)
   *
   * @generated from field: int64 amount_paid_cents = 40;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: int64 amount_due_cents = 41;
   */
  amountDueCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_due_cents = 43;
   */
  tipDueCents: bigint;

  /**
   * Status and locking
   *
   * @generated from field: cortado.v1.InvoiceStatusEnum status = 50;
   */
  status: InvoiceStatusEnum;

  /**
   * @generated from field: bool is_locked = 51;
   */
  isLocked: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp locked_at = 52;
   */
  lockedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 53;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: int32 tip_accounting_version = 54;
   */
  tipAccountingVersion: number;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;

  /**
   * Embedded objects (optional enrichment)
   *
   * @generated from field: optional cortado.v1.User created_by_user = 70;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 71;
   */
  updatedByUser?: User;

  /**
   * Refund tracking
   *
   * Total amount refunded across all refunds
   *
   * @generated from field: int64 total_refunded_cents = 80;
   */
  totalRefundedCents: bigint;

  /**
   * Amount refunded as goodwill (reduces effective total)
   *
   * @generated from field: int64 goodwill_refunded_cents = 81;
   */
  goodwillRefundedCents: bigint;

  /**
   * Payment method override for this invoice (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 90;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * @generated from field: optional string job_id = 91;
   */
  jobId?: string;

  /**
   * How the outstanding tip is spread across payment schedules
   *
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 92;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 8);

/**
 * InvoiceLite is a lightweight invoice representation for list views
 *
 * @generated from message cortado.v1.InvoiceLite
 */
export type InvoiceLite = Message<"cortado.v1.InvoiceLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * @generated from field: int32 invoice_number = 4;
   */
  invoiceNumber: number;

  /**
   * @generated from field: string contact_id = 5;
   */
  contactId: string;

  /**
   * @generated from field: optional string quote_id = 6;
   */
  quoteId?: string;

  /**
   * Summary fields
   *
   * @generated from field: optional string title = 10;
   */
  title?: string;

  /**
   * @generated from field: optional string contact_name = 11;
   */
  contactName?: string;

  /**
   * @generated from field: int64 total_cents = 12;
   */
  totalCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 13;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: int64 amount_due_cents = 14;
   */
  amountDueCents: bigint;

  /**
   * @generated from field: cortado.v1.InvoiceStatusEnum status = 15;
   */
  status: InvoiceStatusEnum;

  /**
   * @generated from field: bool is_locked = 16;
   */
  isLocked: boolean;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_due_cents = 43;
   */
  tipDueCents: bigint;

  /**
   * @generated from field: int32 tip_accounting_version = 54;
   */
  tipAccountingVersion: number;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp sent_at = 20;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string job_id = 22;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.InvoiceLite.
 * Use `create(InvoiceLiteSchema)` to create a new message.
 */
export const InvoiceLiteSchema: GenMessage<InvoiceLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 9);

/**
 * InvoiceLineItem represents a line item in an invoice (from current revision)
 *
 * @generated from message cortado.v1.InvoiceLineItem
 */
export type InvoiceLineItem = Message<"cortado.v1.InvoiceLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string invoice_revision_id = 2;
   */
  invoiceRevisionId: string;

  /**
   * @generated from field: optional string source_quote_line_item_id = 3;
   */
  sourceQuoteLineItemId?: string;

  /**
   * @generated from field: optional string source_item_id = 4;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 7;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: double quantity = 8;
   */
  quantity: number;

  /**
   * @generated from field: string unit = 9;
   */
  unit: string;

  /**
   * @generated from field: int64 line_total_cents = 10;
   */
  lineTotalCents: bigint;

  /**
   * @generated from field: int32 sort_order = 11;
   */
  sortOrder: number;

  /**
   * Per-line-item tax fields
   *
   * @generated from field: bool is_taxable = 12;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 13;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 14;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 15;
   */
  salesTaxRate?: number;

  /**
   * @generated from field: int64 sales_tax_cents = 16;
   */
  salesTaxCents: bigint;

  /**
   * Optional enrichment
   *
   * @generated from field: optional cortado.v1.Item source_item = 20;
   */
  sourceItem?: Item;
};

/**
 * Describes the message cortado.v1.InvoiceLineItem.
 * Use `create(InvoiceLineItemSchema)` to create a new message.
 */
export const InvoiceLineItemSchema: GenMessage<InvoiceLineItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 10);

/**
 * ActiveCheckoutSession represents the currently open Stripe Checkout Session
 * for a payment schedule, when one exists.
 *
 * @generated from message cortado.v1.ActiveCheckoutSession
 */
export type ActiveCheckoutSession = Message<"cortado.v1.ActiveCheckoutSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int64 base_amount_cents = 6;
   */
  baseAmountCents: bigint;

  /**
   * @generated from field: int64 tip_amount_cents = 7;
   */
  tipAmountCents: bigint;
};

/**
 * Describes the message cortado.v1.ActiveCheckoutSession.
 * Use `create(ActiveCheckoutSessionSchema)` to create a new message.
 */
export const ActiveCheckoutSessionSchema: GenMessage<ActiveCheckoutSession> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 11);

/**
 * PaymentSchedule represents a scheduled payment for an invoice
 *
 * @generated from message cortado.v1.PaymentSchedule
 */
export type PaymentSchedule = Message<"cortado.v1.PaymentSchedule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string invoice_revision_id = 4;
   */
  invoiceRevisionId: string;

  /**
   * @generated from field: int32 sequence_number = 5;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 8;
   */
  amountCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 9;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 10;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 11;
   */
  currency: string;

  /**
   * Latest/current payment intent for this schedule
   *
   * @generated from field: optional cortado.v1.PaymentIntent current_payment_intent = 20;
   */
  currentPaymentIntent?: PaymentIntent;

  /**
   * @generated from field: optional cortado.v1.ActiveCheckoutSession active_checkout_session = 21;
   */
  activeCheckoutSession?: ActiveCheckoutSession;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */
  updatedAt?: Timestamp;

  /**
   * Refund tracking
   *
   * Goodwill refunds applied to this schedule
   *
   * @generated from field: int64 goodwill_refunded_cents = 40;
   */
  goodwillRefundedCents: bigint;

  /**
   * @generated from field: int64 expected_tip_cents = 41;
   */
  expectedTipCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_refunded_cents = 43;
   */
  tipRefundedCents: bigint;

  /**
   * @generated from field: int64 tip_disputed_cents = 44;
   */
  tipDisputedCents: bigint;
};

/**
 * Describes the message cortado.v1.PaymentSchedule.
 * Use `create(PaymentScheduleSchema)` to create a new message.
 */
export const PaymentScheduleSchema: GenMessage<PaymentSchedule> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 12);

/**
 * PaymentScheduleLite is a lightweight payment schedule for dashboard views.
 * Includes enriched contact and invoice info for display without additional queries.
 *
 * @generated from message cortado.v1.PaymentScheduleLite
 */
export type PaymentScheduleLite = Message<"cortado.v1.PaymentScheduleLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: int32 sequence_number = 4;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 7;
   */
  amountCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 8;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 9;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * Enriched fields for dashboard display
   *
   * @generated from field: string contact_id = 10;
   */
  contactId: string;

  /**
   * Full name (e.g., "John Smith")
   *
   * @generated from field: string contact_name = 11;
   */
  contactName: string;

  /**
   * Invoice title for context
   *
   * @generated from field: string invoice_title = 12;
   */
  invoiceTitle: string;

  /**
   * Invoice number for display
   *
   * @generated from field: int32 invoice_number = 13;
   */
  invoiceNumber: number;
};

/**
 * Describes the message cortado.v1.PaymentScheduleLite.
 * Use `create(PaymentScheduleLiteSchema)` to create a new message.
 */
export const PaymentScheduleLiteSchema: GenMessage<PaymentScheduleLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 13);

/**
 * QuotePaymentSchedule represents a scheduled payment for a quote - configuration for payment installments on quotes
 *
 * @generated from message cortado.v1.QuotePaymentSchedule
 */
export type QuotePaymentSchedule = Message<"cortado.v1.QuotePaymentSchedule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string quote_id = 3;
   */
  quoteId: string;

  /**
   * @generated from field: string quote_revision_id = 4;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: int32 sequence_number = 5;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */
  dueDate?: Timestamp;

  /**
   * Amount configuration - either percentage or fixed amount
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleAmountTypeEnum amount_type = 8;
   */
  amountType: QuotePaymentScheduleAmountTypeEnum;

  /**
   * e.g., 50.0 for 50%
   *
   * @generated from field: optional double percentage = 9;
   */
  percentage?: number;

  /**
   * Fixed amount in cents
   *
   * @generated from field: optional int64 amount_cents = 10;
   */
  amountCents?: bigint;

  /**
   * Calculated amount for display (computed from percentage × total or from fixed amount)
   *
   * @generated from field: optional int64 calculated_amount_cents = 11;
   */
  calculatedAmountCents?: bigint;

  /**
   * Tip-on-last logic: indicates this is the last schedule in the sequence (tip added here)
   *
   * @generated from field: bool is_last_schedule = 12;
   */
  isLastSchedule: boolean;

  /**
   * Base plus this schedule's share of the enforced tip; set on every schedule with a share > 0
   *
   * @generated from field: optional int64 amount_with_tip_cents = 13;
   */
  amountWithTipCents?: bigint;

  /**
   * How due_date is interpreted. UNSPECIFIED is treated as ABSOLUTE.
   * AFTER_ACCEPTANCE / BEFORE_EVENT use due_offset_days; due_date is a preview.
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleDueDateAnchorEnum due_date_anchor = 14;
   */
  dueDateAnchor: QuotePaymentScheduleDueDateAnchorEnum;

  /**
   * @generated from field: int32 due_offset_days = 15;
   */
  dueOffsetDays: number;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.QuotePaymentSchedule.
 * Use `create(QuotePaymentScheduleSchema)` to create a new message.
 */
export const QuotePaymentScheduleSchema: GenMessage<QuotePaymentSchedule> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 14);

/**
 * QuotePaymentScheduleInput represents input data for creating/updating quote payment schedules
 *
 * @generated from message cortado.v1.QuotePaymentScheduleInput
 */
export type QuotePaymentScheduleInput = Message<"cortado.v1.QuotePaymentScheduleInput"> & {
  /**
   * @generated from field: int32 sequence_number = 1;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * Exactly one of percentage or amount_cents must be set based on amount_type
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleAmountTypeEnum amount_type = 4;
   */
  amountType: QuotePaymentScheduleAmountTypeEnum;

  /**
   * @generated from field: optional double percentage = 5;
   */
  percentage?: number;

  /**
   * @generated from field: optional int64 amount_cents = 6;
   */
  amountCents?: bigint;

  /**
   * How due_date is interpreted. UNSPECIFIED is treated as ABSOLUTE.
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleDueDateAnchorEnum due_date_anchor = 7;
   */
  dueDateAnchor: QuotePaymentScheduleDueDateAnchorEnum;

  /**
   * @generated from field: int32 due_offset_days = 8;
   */
  dueOffsetDays: number;
};

/**
 * Describes the message cortado.v1.QuotePaymentScheduleInput.
 * Use `create(QuotePaymentScheduleInputSchema)` to create a new message.
 */
export const QuotePaymentScheduleInputSchema: GenMessage<QuotePaymentScheduleInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 15);

/**
 * PaymentIntent represents a Stripe payment intent
 *
 * @generated from message cortado.v1.PaymentIntent
 */
export type PaymentIntent = Message<"cortado.v1.PaymentIntent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 4;
   */
  paymentScheduleId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId: string;

  /**
   * @generated from field: int64 amount_cents = 6;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentIntentStatusEnum status = 7;
   */
  status: PaymentIntentStatusEnum;

  /**
   * @generated from field: string client_secret = 8;
   */
  clientSecret: string;

  /**
   * Payment method details
   *
   * @generated from field: optional string payment_method_id = 10;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 11;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 12;
   */
  paymentMethodLast4?: string;

  /**
   * @generated from field: optional string payment_method_brand = 13;
   */
  paymentMethodBrand?: string;

  /**
   * Status timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp paid_at = 20;
   */
  paidAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp failed_at = 21;
   */
  failedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp canceled_at = 22;
   */
  canceledAt?: Timestamp;

  /**
   * Failure details
   *
   * @generated from field: optional string failure_message = 30;
   */
  failureMessage?: string;

  /**
   * @generated from field: optional string failure_code = 31;
   */
  failureCode?: string;

  /**
   * Financial details
   *
   * @generated from field: optional int64 stripe_fee_cents = 40;
   */
  stripeFeeCents?: bigint;

  /**
   * @generated from field: optional int64 net_amount_cents = 41;
   */
  netAmountCents?: bigint;

  /**
   * Raw Stripe data
   *
   * @generated from field: optional string metadata_json = 50;
   */
  metadataJson?: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 61;
   */
  updatedAt?: Timestamp;

  /**
   * Nested payments (Stripe Charges) for this payment intent
   *
   * @generated from field: repeated cortado.v1.StripePayment payments = 70;
   */
  payments: StripePayment[];
};

/**
 * Describes the message cortado.v1.PaymentIntent.
 * Use `create(PaymentIntentSchema)` to create a new message.
 */
export const PaymentIntentSchema: GenMessage<PaymentIntent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 16);

/**
 * StripePayment represents an individual Stripe Charge (payment attempt)
 * A single PaymentIntent can have multiple charges (e.g., failed card attempt + successful retry)
 *
 * @generated from message cortado.v1.StripePayment
 */
export type StripePayment = Message<"cortado.v1.StripePayment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Replaced payment_intent_id
   *
   * @generated from field: optional string checkout_session_id = 3;
   */
  checkoutSessionId?: string;

  /**
   * @generated from field: string stripe_charge_id = 4;
   */
  stripeChargeId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId: string;

  /**
   * Core charge data
   *
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.StripePaymentStatusEnum status = 11;
   */
  status: StripePaymentStatusEnum;

  /**
   * @generated from field: bool paid = 12;
   */
  paid: boolean;

  /**
   * Outcome details (from Stripe charge.outcome)
   *
   * @generated from field: optional cortado.v1.PaymentOutcomeTypeEnum outcome_type = 20;
   */
  outcomeType?: PaymentOutcomeTypeEnum;

  /**
   * @generated from field: optional cortado.v1.PaymentNetworkStatusEnum outcome_network_status = 21;
   */
  outcomeNetworkStatus?: PaymentNetworkStatusEnum;

  /**
   * @generated from field: optional string outcome_reason = 22;
   */
  outcomeReason?: string;

  /**
   * @generated from field: optional cortado.v1.PaymentRiskLevelEnum outcome_risk_level = 23;
   */
  outcomeRiskLevel?: PaymentRiskLevelEnum;

  /**
   * @generated from field: optional int32 outcome_risk_score = 24;
   */
  outcomeRiskScore?: number;

  /**
   * @generated from field: optional string outcome_seller_message = 25;
   */
  outcomeSellerMessage?: string;

  /**
   * Failure details
   *
   * @generated from field: optional string failure_code = 30;
   */
  failureCode?: string;

  /**
   * @generated from field: optional string failure_message = 31;
   */
  failureMessage?: string;

  /**
   * Payment method details
   *
   * @generated from field: optional string payment_method_id = 40;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 41;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 42;
   */
  paymentMethodLast4?: string;

  /**
   * @generated from field: optional string payment_method_brand = 43;
   */
  paymentMethodBrand?: string;

  /**
   * @generated from field: optional string payment_method_wallet_type = 44;
   */
  paymentMethodWalletType?: string;

  /**
   * Card verification checks
   *
   * @generated from field: optional cortado.v1.CardCheckResultEnum cvc_check = 50;
   */
  cvcCheck?: CardCheckResultEnum;

  /**
   * @generated from field: optional cortado.v1.CardCheckResultEnum address_line1_check = 51;
   */
  addressLine1Check?: CardCheckResultEnum;

  /**
   * @generated from field: optional cortado.v1.CardCheckResultEnum address_postal_code_check = 52;
   */
  addressPostalCodeCheck?: CardCheckResultEnum;

  /**
   * Refund tracking
   *
   * @generated from field: bool refunded = 60;
   */
  refunded: boolean;

  /**
   * @generated from field: int64 amount_refunded_cents = 61;
   */
  amountRefundedCents: bigint;

  /**
   * Financial reconciliation
   *
   * @generated from field: optional string balance_transaction_id = 70;
   */
  balanceTransactionId?: string;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp stripe_created_at = 80;
   */
  stripeCreatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 81;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 82;
   */
  updatedAt?: Timestamp;

  /**
   * Currency (ISO 4217 code, e.g., "USD", "EUR")
   *
   * @generated from field: string currency = 85;
   */
  currency: string;

  /**
   * Extended refund tracking (for admin-initiated refunds)
   *
   * @generated from field: optional string refund_reason = 90;
   */
  refundReason?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp refunded_at = 91;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: optional string refunded_by = 92;
   */
  refundedBy?: string;

  /**
   * Fee tracking (from balance transaction)
   *
   * @generated from field: optional int64 stripe_fee_cents = 95;
   */
  stripeFeeCents?: bigint;

  /**
   * @generated from field: optional int64 application_fee_cents = 96;
   */
  applicationFeeCents?: bigint;

  /**
   * @generated from field: optional int64 net_amount_cents = 97;
   */
  netAmountCents?: bigint;
};

/**
 * Describes the message cortado.v1.StripePayment.
 * Use `create(StripePaymentSchema)` to create a new message.
 */
export const StripePaymentSchema: GenMessage<StripePayment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 17);

/**
 * ManualPayment represents a payment recorded outside of Stripe (check, wire transfer, cash, ACH)
 *
 * @generated from message cortado.v1.ManualPayment
 */
export type ManualPayment = Message<"cortado.v1.ManualPayment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: optional string payment_schedule_id = 4;
   */
  paymentScheduleId?: string;

  /**
   * Payment details
   *
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 11;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 12;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 13;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 14;
   */
  notes?: string;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 15;
   */
  currency: string;

  /**
   * Voiding (for admin corrections)
   *
   * @generated from field: bool voided = 20;
   */
  voided: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp voided_at = 21;
   */
  voidedAt?: Timestamp;

  /**
   * @generated from field: optional string voided_by = 22;
   */
  voidedBy?: string;

  /**
   * @generated from field: optional string void_reason = 23;
   */
  voidReason?: string;

  /**
   * Recording info
   *
   * @generated from field: string recorded_by = 30;
   */
  recordedBy: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * Enrichment
   *
   * @generated from field: optional cortado.v1.User recorded_by_user = 50;
   */
  recordedByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User voided_by_user = 51;
   */
  voidedByUser?: User;
};

/**
 * Describes the message cortado.v1.ManualPayment.
 * Use `create(ManualPaymentSchema)` to create a new message.
 */
export const ManualPaymentSchema: GenMessage<ManualPayment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 18);

/**
 * Item represents a catalog item
 *
 * @generated from message cortado.v1.Item
 */
export type Item = Message<"cortado.v1.Item"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: float price = 5;
   */
  price: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 6;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: bool always_include = 7;
   */
  alwaysInclude: boolean;

  /**
   * @generated from field: bool include_on_form = 8;
   */
  includeOnForm: boolean;

  /**
   * @generated from field: int32 form_display_order = 13;
   */
  formDisplayOrder: number;

  /**
   * @generated from field: bool offer_as_addon = 14;
   */
  offerAsAddon: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 12;
   */
  updatedBy: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: cortado.v1.ItemKindEnum item_kind = 22;
   */
  itemKind: ItemKindEnum;

  /**
   * @generated from field: double mileage_threshold_miles = 23;
   */
  mileageThresholdMiles: number;

  /**
   * Gallery images for this item, ordered by sort_order. The cover image has
   * is_primary = true. Populated on list/get/create/update responses.
   *
   * @generated from field: repeated cortado.v1.ItemImage images = 24;
   */
  images: ItemImage[];
};

/**
 * Describes the message cortado.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema: GenMessage<Item> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 19);

/**
 * LineItemImage is the customer-facing view of one catalog item image, shown
 * beside a quote or invoice line item in the portal.
 *
 * @generated from message cortado.v1.LineItemImage
 */
export type LineItemImage = Message<"cortado.v1.LineItemImage"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string alt_text = 2;
   */
  altText: string;

  /**
   * @generated from field: optional int32 width_px = 3;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 4;
   */
  heightPx?: number;
};

/**
 * Describes the message cortado.v1.LineItemImage.
 * Use `create(LineItemImageSchema)` to create a new message.
 */
export const LineItemImageSchema: GenMessage<LineItemImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 20);

/**
 * ItemImage is one gallery image on a catalog item. Images are served from a
 * public bucket, so public_url is stable and safe to embed in the customer
 * portal, emails, and PDFs.
 *
 * @generated from message cortado.v1.ItemImage
 */
export type ItemImage = Message<"cortado.v1.ItemImage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string public_url = 20;
   */
  publicUrl: string;

  /**
   * @generated from field: string filename = 21;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 22;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 23;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional int32 width_px = 24;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 25;
   */
  heightPx?: number;

  /**
   * @generated from field: string alt_text = 26;
   */
  altText: string;

  /**
   * @generated from field: int32 sort_order = 27;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_primary = 50;
   */
  isPrimary: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.ItemImage.
 * Use `create(ItemImageSchema)` to create a new message.
 */
export const ItemImageSchema: GenMessage<ItemImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 21);

/**
 * TaxRate represents a tax rate/sales tax in the system
 *
 * @generated from message cortado.v1.TaxRate
 */
export type TaxRate = Message<"cortado.v1.TaxRate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tax_type = 3;
   */
  taxType: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: float percentage = 5;
   */
  percentage: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 9;
   */
  updatedBy: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 10;
   */
  archivedAt?: Timestamp;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;
};

/**
 * Describes the message cortado.v1.TaxRate.
 * Use `create(TaxRateSchema)` to create a new message.
 */
export const TaxRateSchema: GenMessage<TaxRate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 22);

/**
 * Discount represents a discount in the system
 *
 * @generated from message cortado.v1.Discount
 */
export type Discount = Message<"cortado.v1.Discount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: cortado.v1.DiscountTypeEnum discount_type = 5;
   */
  discountType: DiscountTypeEnum;

  /**
   * @generated from field: float value = 6;
   */
  value: number;

  /**
   * @generated from field: optional bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 11;
   */
  updatedBy?: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;
};

/**
 * Describes the message cortado.v1.Discount.
 * Use `create(DiscountSchema)` to create a new message.
 */
export const DiscountSchema: GenMessage<Discount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 23);

/**
 * @generated from message cortado.v1.QuoteTemplateItem
 */
export type QuoteTemplateItem = Message<"cortado.v1.QuoteTemplateItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string template_id = 2;
   */
  templateId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: cortado.v1.QuoteTemplateItemScalingType scaling_type = 4;
   */
  scalingType: QuoteTemplateItemScalingType;

  /**
   * @generated from field: int64 rate_cents = 5;
   */
  rateCents: bigint;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: optional cortado.v1.Item item = 7;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.QuoteTemplateItem.
 * Use `create(QuoteTemplateItemSchema)` to create a new message.
 */
export const QuoteTemplateItemSchema: GenMessage<QuoteTemplateItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 24);

/**
 * QuoteTemplate represents event-type-specific pricing configuration
 *
 * @generated from message cortado.v1.QuoteTemplate
 */
export type QuoteTemplate = Message<"cortado.v1.QuoteTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 3 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional string base_item_id = 4;
   */
  baseItemId?: string;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional string hourly_item_id = 5;
   */
  hourlyItemId?: string;

  /**
   * @generated from field: int32 minimum_hours = 6;
   */
  minimumHours: number;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * Deprecated: Use template_items with per-item rate_cents instead.
   *
   * @generated from field: int64 base_item_rate_cents = 12;
   */
  baseItemRateCents: bigint;

  /**
   * Deprecated: Use template_items with per-item rate_cents instead.
   *
   * @generated from field: int64 hourly_item_rate_cents = 13;
   */
  hourlyItemRateCents: bigint;

  /**
   * @generated from field: string title = 14;
   */
  title: string;

  /**
   * @generated from field: optional string quote_title = 15;
   */
  quoteTitle?: string;

  /**
   * @generated from field: optional string quote_description = 16;
   */
  quoteDescription?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: optional string event_type_key = 25;
   */
  eventTypeKey?: string;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional cortado.v1.Item base_item = 22;
   */
  baseItem?: Item;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional cortado.v1.Item hourly_item = 23;
   */
  hourlyItem?: Item;

  /**
   * @generated from field: repeated cortado.v1.QuoteTemplateItem template_items = 24;
   */
  templateItems: QuoteTemplateItem[];
};

/**
 * Describes the message cortado.v1.QuoteTemplate.
 * Use `create(QuoteTemplateSchema)` to create a new message.
 */
export const QuoteTemplateSchema: GenMessage<QuoteTemplate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 25);

/**
 * Payment represents a payment for an invoice (DEPRECATED - use PaymentIntent)
 *
 * @generated from message cortado.v1.Payment
 */
export type Payment = Message<"cortado.v1.Payment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string payment_schedule_item_id = 2;
   */
  paymentScheduleItemId?: string;

  /**
   * @generated from field: float amount_paid = 3;
   */
  amountPaid: number;

  /**
   * @generated from field: optional string payment_method_id = 4;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 5;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_intent_id = 6;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: optional string charge_id = 7;
   */
  chargeId?: string;

  /**
   * @generated from field: cortado.v1.PaymentStatusEnum payment_status = 9;
   */
  paymentStatus: PaymentStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 26);

/**
 * QuoteItem is the old name for QuoteLineItem (DEPRECATED - use QuoteLineItem)
 *
 * @generated from message cortado.v1.QuoteItem
 */
export type QuoteItem = Message<"cortado.v1.QuoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_id = 2;
   */
  quoteId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int32 quantity = 6;
   */
  quantity: number;

  /**
   * @generated from field: float unit_price = 7;
   */
  unitPrice: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 8;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: int32 ordering = 9;
   */
  ordering: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Embedded item details
   *
   * @generated from field: optional cortado.v1.Item item = 20;
   */
  item?: Item;

  /**
   * Pre-calculated
   *
   * @generated from field: float line_total = 30;
   */
  lineTotal: number;
};

/**
 * Describes the message cortado.v1.QuoteItem.
 * Use `create(QuoteItemSchema)` to create a new message.
 */
export const QuoteItemSchema: GenMessage<QuoteItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 27);

/**
 * InvoiceItem is the old name for InvoiceLineItem (DEPRECATED - use InvoiceLineItem)
 *
 * @generated from message cortado.v1.InvoiceItem
 */
export type InvoiceItem = Message<"cortado.v1.InvoiceItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string invoice_id = 2;
   */
  invoiceId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int32 quantity = 6;
   */
  quantity: number;

  /**
   * @generated from field: float unit_price = 7;
   */
  unitPrice: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 8;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: int32 ordering = 9;
   */
  ordering: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * @generated from field: optional cortado.v1.Item item = 20;
   */
  item?: Item;

  /**
   * @generated from field: float line_total = 30;
   */
  lineTotal: number;
};

/**
 * Describes the message cortado.v1.InvoiceItem.
 * Use `create(InvoiceItemSchema)` to create a new message.
 */
export const InvoiceItemSchema: GenMessage<InvoiceItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 28);

/**
 * CreateQuoteItemInput is used when creating a quote to specify item details
 *
 * @generated from message cortado.v1.CreateQuoteItemInput
 */
export type CreateQuoteItemInput = Message<"cortado.v1.CreateQuoteItemInput"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: optional float unit_price_override = 3;
   */
  unitPriceOverride?: number;

  /**
   * @generated from field: optional string title_override = 4;
   */
  titleOverride?: string;

  /**
   * @generated from field: optional string description_override = 5;
   */
  descriptionOverride?: string;
};

/**
 * Describes the message cortado.v1.CreateQuoteItemInput.
 * Use `create(CreateQuoteItemInputSchema)` to create a new message.
 */
export const CreateQuoteItemInputSchema: GenMessage<CreateQuoteItemInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 29);

/**
 * RecordManualPaymentRequest is used to record a payment made outside of Stripe
 *
 * @generated from message cortado.v1.RecordManualPaymentRequest
 */
export type RecordManualPaymentRequest = Message<"cortado.v1.RecordManualPaymentRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 2;
   */
  paymentScheduleId: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 4;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 5;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 6;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 7;
   */
  notes?: string;

  /**
   * Send receipt email to customer
   *
   * @generated from field: bool send_receipt_email = 8;
   */
  sendReceiptEmail: boolean;

  /**
   * Client-generated idempotency key (e.g. a UUID minted per form entry).
   * Resubmissions of the same logical payment must reuse the same key; distinct
   * payments must use distinct keys. When absent, the server falls back to a
   * key derived from (invoice, schedule, amount, method, payment_date), which
   * cannot distinguish two legitimate same-day/same-amount payments.
   *
   * @generated from field: optional string idempotency_key = 9;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.RecordManualPaymentRequest.
 * Use `create(RecordManualPaymentRequestSchema)` to create a new message.
 */
export const RecordManualPaymentRequestSchema: GenMessage<RecordManualPaymentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 30);

/**
 * RecordManualPaymentResponse contains the created payment and updated invoice
 *
 * @generated from message cortado.v1.RecordManualPaymentResponse
 */
export type RecordManualPaymentResponse = Message<"cortado.v1.RecordManualPaymentResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.RecordManualPaymentResponse.
 * Use `create(RecordManualPaymentResponseSchema)` to create a new message.
 */
export const RecordManualPaymentResponseSchema: GenMessage<RecordManualPaymentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 31);

/**
 * BatchManualPaymentEntry represents a single payment entry for batch recording
 *
 * @generated from message cortado.v1.BatchManualPaymentEntry
 */
export type BatchManualPaymentEntry = Message<"cortado.v1.BatchManualPaymentEntry"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * optional - if not provided, will use first unpaid schedule
   *
   * @generated from field: optional string payment_schedule_id = 2;
   */
  paymentScheduleId?: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 4;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 5;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 6;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 7;
   */
  notes?: string;

  /**
   * Client-generated idempotency key (see RecordManualPaymentRequest.idempotency_key).
   *
   * @generated from field: optional string idempotency_key = 8;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.BatchManualPaymentEntry.
 * Use `create(BatchManualPaymentEntrySchema)` to create a new message.
 */
export const BatchManualPaymentEntrySchema: GenMessage<BatchManualPaymentEntry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 32);

/**
 * RecordBatchManualPaymentsRequest records multiple manual payments atomically
 *
 * @generated from message cortado.v1.RecordBatchManualPaymentsRequest
 */
export type RecordBatchManualPaymentsRequest = Message<"cortado.v1.RecordBatchManualPaymentsRequest"> & {
  /**
   * @generated from field: repeated cortado.v1.BatchManualPaymentEntry payments = 1;
   */
  payments: BatchManualPaymentEntry[];

  /**
   * Send receipt emails for all payments
   *
   * @generated from field: bool send_receipt_emails = 2;
   */
  sendReceiptEmails: boolean;
};

/**
 * Describes the message cortado.v1.RecordBatchManualPaymentsRequest.
 * Use `create(RecordBatchManualPaymentsRequestSchema)` to create a new message.
 */
export const RecordBatchManualPaymentsRequestSchema: GenMessage<RecordBatchManualPaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 33);

/**
 * RecordBatchManualPaymentsResponse contains all recorded payments
 *
 * @generated from message cortado.v1.RecordBatchManualPaymentsResponse
 */
export type RecordBatchManualPaymentsResponse = Message<"cortado.v1.RecordBatchManualPaymentsResponse"> & {
  /**
   * All recorded payments
   *
   * @generated from field: repeated cortado.v1.ManualPayment payments = 1;
   */
  payments: ManualPayment[];

  /**
   * Number of payments successfully recorded
   *
   * @generated from field: int32 success_count = 2;
   */
  successCount: number;
};

/**
 * Describes the message cortado.v1.RecordBatchManualPaymentsResponse.
 * Use `create(RecordBatchManualPaymentsResponseSchema)` to create a new message.
 */
export const RecordBatchManualPaymentsResponseSchema: GenMessage<RecordBatchManualPaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 34);

/**
 * ProcessStripeRefundRequest is used to initiate a refund through Stripe
 *
 * @generated from message cortado.v1.ProcessStripeRefundRequest
 */
export type ProcessStripeRefundRequest = Message<"cortado.v1.ProcessStripeRefundRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * true = goodwill refund (reduces invoice total), false = customer will repay
   *
   * @generated from field: bool is_goodwill = 4;
   */
  isGoodwill: boolean;
};

/**
 * Describes the message cortado.v1.ProcessStripeRefundRequest.
 * Use `create(ProcessStripeRefundRequestSchema)` to create a new message.
 */
export const ProcessStripeRefundRequestSchema: GenMessage<ProcessStripeRefundRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 35);

/**
 * ProcessStripeRefundResponse contains the updated payment and invoice
 *
 * @generated from message cortado.v1.ProcessStripeRefundResponse
 */
export type ProcessStripeRefundResponse = Message<"cortado.v1.ProcessStripeRefundResponse"> & {
  /**
   * @generated from field: cortado.v1.StripePayment payment = 1;
   */
  payment?: StripePayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;

  /**
   * @generated from field: string stripe_refund_id = 3;
   */
  stripeRefundId: string;

  /**
   * The created refund record
   *
   * @generated from field: cortado.v1.InvoiceRefund refund = 4;
   */
  refund?: InvoiceRefund;
};

/**
 * Describes the message cortado.v1.ProcessStripeRefundResponse.
 * Use `create(ProcessStripeRefundResponseSchema)` to create a new message.
 */
export const ProcessStripeRefundResponseSchema: GenMessage<ProcessStripeRefundResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 36);

/**
 * InvoiceRefund represents a refund record for an invoice
 *
 * @generated from message cortado.v1.InvoiceRefund
 */
export type InvoiceRefund = Message<"cortado.v1.InvoiceRefund"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_id = 4;
   */
  paymentId: string;

  /**
   * @generated from field: optional string payment_schedule_id = 5;
   */
  paymentScheduleId?: string;

  /**
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: bool is_goodwill = 11;
   */
  isGoodwill: boolean;

  /**
   * @generated from field: optional string reason = 12;
   */
  reason?: string;

  /**
   * @generated from field: optional string stripe_refund_id = 13;
   */
  stripeRefundId?: string;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 14;
   */
  currency: string;

  /**
   * @generated from field: optional string refunded_by = 20;
   */
  refundedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp refunded_at = 21;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.InvoiceRefund.
 * Use `create(InvoiceRefundSchema)` to create a new message.
 */
export const InvoiceRefundSchema: GenMessage<InvoiceRefund> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 37);

/**
 * VoidManualPaymentRequest is used to void a manual payment (admin correction)
 *
 * @generated from message cortado.v1.VoidManualPaymentRequest
 */
export type VoidManualPaymentRequest = Message<"cortado.v1.VoidManualPaymentRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * Send void notification email to customer
   *
   * @generated from field: bool send_void_notification = 3;
   */
  sendVoidNotification: boolean;
};

/**
 * Describes the message cortado.v1.VoidManualPaymentRequest.
 * Use `create(VoidManualPaymentRequestSchema)` to create a new message.
 */
export const VoidManualPaymentRequestSchema: GenMessage<VoidManualPaymentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 38);

/**
 * VoidManualPaymentResponse contains the voided payment and updated invoice
 *
 * @generated from message cortado.v1.VoidManualPaymentResponse
 */
export type VoidManualPaymentResponse = Message<"cortado.v1.VoidManualPaymentResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.VoidManualPaymentResponse.
 * Use `create(VoidManualPaymentResponseSchema)` to create a new message.
 */
export const VoidManualPaymentResponseSchema: GenMessage<VoidManualPaymentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 39);

/**
 * ListInvoicePaymentsRequest is used to list all payments for an invoice
 *
 * @generated from message cortado.v1.ListInvoicePaymentsRequest
 */
export type ListInvoicePaymentsRequest = Message<"cortado.v1.ListInvoicePaymentsRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: optional int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;

  /**
   * Date range filter
   *
   * @generated from field: optional google.protobuf.Timestamp date_from = 10;
   */
  dateFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp date_to = 11;
   */
  dateTo?: Timestamp;

  /**
   * Amount range filter (in cents)
   *
   * @generated from field: optional int64 amount_min_cents = 12;
   */
  amountMinCents?: bigint;

  /**
   * @generated from field: optional int64 amount_max_cents = 13;
   */
  amountMaxCents?: bigint;

  /**
   * Payment source filter (stripe vs manual)
   *
   * @generated from field: optional bool stripe_only = 14;
   */
  stripeOnly?: boolean;

  /**
   * @generated from field: optional bool manual_only = 15;
   */
  manualOnly?: boolean;

  /**
   * For manual payments: method filter
   *
   * @generated from field: repeated cortado.v1.ManualPaymentMethodEnum manual_methods = 16;
   */
  manualMethods: ManualPaymentMethodEnum[];

  /**
   * Text search for reference numbers (manual payments only)
   *
   * @generated from field: optional string reference_search = 17;
   */
  referenceSearch?: string;

  /**
   * Include voided manual payments (default: false)
   *
   * @generated from field: optional bool include_voided = 18;
   */
  includeVoided?: boolean;
};

/**
 * Describes the message cortado.v1.ListInvoicePaymentsRequest.
 * Use `create(ListInvoicePaymentsRequestSchema)` to create a new message.
 */
export const ListInvoicePaymentsRequestSchema: GenMessage<ListInvoicePaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 40);

/**
 * ListInvoicePaymentsResponse contains both Stripe and manual payments
 *
 * @generated from message cortado.v1.ListInvoicePaymentsResponse
 */
export type ListInvoicePaymentsResponse = Message<"cortado.v1.ListInvoicePaymentsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripePayment stripe_payments = 1;
   */
  stripePayments: StripePayment[];

  /**
   * @generated from field: repeated cortado.v1.ManualPayment manual_payments = 2;
   */
  manualPayments: ManualPayment[];

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListInvoicePaymentsResponse.
 * Use `create(ListInvoicePaymentsResponseSchema)` to create a new message.
 */
export const ListInvoicePaymentsResponseSchema: GenMessage<ListInvoicePaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 41);

/**
 * ExportInvoicePaymentsRequest exports payments for an invoice as CSV
 * Uses the same filter options as ListInvoicePaymentsRequest
 *
 * @generated from message cortado.v1.ExportInvoicePaymentsRequest
 */
export type ExportInvoicePaymentsRequest = Message<"cortado.v1.ExportInvoicePaymentsRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Date range filter
   *
   * @generated from field: optional google.protobuf.Timestamp date_from = 10;
   */
  dateFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp date_to = 11;
   */
  dateTo?: Timestamp;

  /**
   * Amount range filter (in cents)
   *
   * @generated from field: optional int64 amount_min_cents = 12;
   */
  amountMinCents?: bigint;

  /**
   * @generated from field: optional int64 amount_max_cents = 13;
   */
  amountMaxCents?: bigint;

  /**
   * Payment source filter (stripe vs manual)
   *
   * @generated from field: optional bool stripe_only = 14;
   */
  stripeOnly?: boolean;

  /**
   * @generated from field: optional bool manual_only = 15;
   */
  manualOnly?: boolean;

  /**
   * For manual payments: method filter
   *
   * @generated from field: repeated cortado.v1.ManualPaymentMethodEnum manual_methods = 16;
   */
  manualMethods: ManualPaymentMethodEnum[];

  /**
   * Text search for reference numbers (manual payments only)
   *
   * @generated from field: optional string reference_search = 17;
   */
  referenceSearch?: string;

  /**
   * Include voided manual payments (default: false)
   *
   * @generated from field: optional bool include_voided = 18;
   */
  includeVoided?: boolean;
};

/**
 * Describes the message cortado.v1.ExportInvoicePaymentsRequest.
 * Use `create(ExportInvoicePaymentsRequestSchema)` to create a new message.
 */
export const ExportInvoicePaymentsRequestSchema: GenMessage<ExportInvoicePaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 42);

/**
 * ExportInvoicePaymentsResponse contains the CSV data
 *
 * @generated from message cortado.v1.ExportInvoicePaymentsResponse
 */
export type ExportInvoicePaymentsResponse = Message<"cortado.v1.ExportInvoicePaymentsResponse"> & {
  /**
   * CSV file content
   *
   * @generated from field: bytes csv_data = 1;
   */
  csvData: Uint8Array;

  /**
   * Suggested filename for download
   *
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * Number of payment rows exported
   *
   * @generated from field: int32 row_count = 3;
   */
  rowCount: number;
};

/**
 * Describes the message cortado.v1.ExportInvoicePaymentsResponse.
 * Use `create(ExportInvoicePaymentsResponseSchema)` to create a new message.
 */
export const ExportInvoicePaymentsResponseSchema: GenMessage<ExportInvoicePaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 43);

/**
 * VoidInvoiceRequest is used to cancel an invoice
 *
 * @generated from message cortado.v1.VoidInvoiceRequest
 */
export type VoidInvoiceRequest = Message<"cortado.v1.VoidInvoiceRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Optional reason for voiding
   *
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * When false and payments exist, returns FAILED_PRECONDITION with details. When true, proceeds with void.
   *
   * @generated from field: bool force = 3;
   */
  force: boolean;
};

/**
 * Describes the message cortado.v1.VoidInvoiceRequest.
 * Use `create(VoidInvoiceRequestSchema)` to create a new message.
 */
export const VoidInvoiceRequestSchema: GenMessage<VoidInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 44);

/**
 * VoidInvoiceResponse contains the voided invoice
 *
 * @generated from message cortado.v1.VoidInvoiceResponse
 */
export type VoidInvoiceResponse = Message<"cortado.v1.VoidInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.VoidInvoiceResponse.
 * Use `create(VoidInvoiceResponseSchema)` to create a new message.
 */
export const VoidInvoiceResponseSchema: GenMessage<VoidInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 45);

/**
 * MarkInvoiceAsPaidRequest marks an invoice as fully paid by creating a manual payment
 *
 * @generated from message cortado.v1.MarkInvoiceAsPaidRequest
 */
export type MarkInvoiceAsPaidRequest = Message<"cortado.v1.MarkInvoiceAsPaidRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Method of payment (cash, check, wire, other)
   *
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 2;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * Optional reference (check number, wire ID, etc.)
   *
   * @generated from field: optional string reference_number = 3;
   */
  referenceNumber?: string;

  /**
   * Optional notes about the payment
   *
   * @generated from field: optional string notes = 4;
   */
  notes?: string;
};

/**
 * Describes the message cortado.v1.MarkInvoiceAsPaidRequest.
 * Use `create(MarkInvoiceAsPaidRequestSchema)` to create a new message.
 */
export const MarkInvoiceAsPaidRequestSchema: GenMessage<MarkInvoiceAsPaidRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 46);

/**
 * MarkInvoiceAsPaidResponse contains the created payment(s) and updated invoice
 *
 * @generated from message cortado.v1.MarkInvoiceAsPaidResponse
 */
export type MarkInvoiceAsPaidResponse = Message<"cortado.v1.MarkInvoiceAsPaidResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;

  /**
   * @generated from field: repeated cortado.v1.ManualPayment payments = 3;
   */
  payments: ManualPayment[];
};

/**
 * Describes the message cortado.v1.MarkInvoiceAsPaidResponse.
 * Use `create(MarkInvoiceAsPaidResponseSchema)` to create a new message.
 */
export const MarkInvoiceAsPaidResponseSchema: GenMessage<MarkInvoiceAsPaidResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 47);

/**
 * SendInvoiceRequest sends an invoice email to the customer
 * For DRAFT invoices, updates status to SENT. For already-sent invoices, resends the email.
 *
 * @generated from message cortado.v1.SendInvoiceRequest
 */
export type SendInvoiceRequest = Message<"cortado.v1.SendInvoiceRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Client-generated UUID for this logical send operation. Reuse it when
   * retrying an ambiguous request; generate a new UUID for an intentional resend.
   *
   * @generated from field: optional string idempotency_key = 2;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.SendInvoiceRequest.
 * Use `create(SendInvoiceRequestSchema)` to create a new message.
 */
export const SendInvoiceRequestSchema: GenMessage<SendInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 48);

/**
 * SendInvoiceResponse returns the updated invoice after sending
 *
 * @generated from message cortado.v1.SendInvoiceResponse
 */
export type SendInvoiceResponse = Message<"cortado.v1.SendInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.SendInvoiceResponse.
 * Use `create(SendInvoiceResponseSchema)` to create a new message.
 */
export const SendInvoiceResponseSchema: GenMessage<SendInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 49);

/**
 * SendPaymentReminderRequest sends a payment reminder email for an invoice
 *
 * @generated from message cortado.v1.SendPaymentReminderRequest
 */
export type SendPaymentReminderRequest = Message<"cortado.v1.SendPaymentReminderRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Optional custom message to include in the email
   *
   * @generated from field: optional string custom_message = 2;
   */
  customMessage?: string;
};

/**
 * Describes the message cortado.v1.SendPaymentReminderRequest.
 * Use `create(SendPaymentReminderRequestSchema)` to create a new message.
 */
export const SendPaymentReminderRequestSchema: GenMessage<SendPaymentReminderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 50);

/**
 * SendPaymentReminderResponse contains info about the sent reminder
 *
 * @generated from message cortado.v1.SendPaymentReminderResponse
 */
export type SendPaymentReminderResponse = Message<"cortado.v1.SendPaymentReminderResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * e.g., "Reminder sent to customer@example.com"
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.SendPaymentReminderResponse.
 * Use `create(SendPaymentReminderResponseSchema)` to create a new message.
 */
export const SendPaymentReminderResponseSchema: GenMessage<SendPaymentReminderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 51);

/**
 * GenerateInvoicePortalLinkRequest is used to generate a shareable portal link for an invoice
 * The link allows customers to view and pay the invoice without logging in
 *
 * @generated from message cortado.v1.GenerateInvoicePortalLinkRequest
 */
export type GenerateInvoicePortalLinkRequest = Message<"cortado.v1.GenerateInvoicePortalLinkRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Retained for compatibility; new links use a fixed 30-day lifetime
   *
   * @generated from field: optional int64 expires_in_hours = 2 [deprecated = true];
   * @deprecated
   */
  expiresInHours?: bigint;

  /**
   * Legacy: true maps to anonymous; false maps to recipient
   *
   * @generated from field: bool omit_token = 3 [deprecated = true];
   * @deprecated
   */
  omitToken: boolean;

  /**
   * @generated from field: optional cortado.v1.PortalAttributionModeEnum attribution_mode = 4;
   */
  attributionMode?: PortalAttributionModeEnum;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePortalLinkRequest.
 * Use `create(GenerateInvoicePortalLinkRequestSchema)` to create a new message.
 */
export const GenerateInvoicePortalLinkRequestSchema: GenMessage<GenerateInvoicePortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 52);

/**
 * GenerateInvoicePortalLinkResponse contains the generated portal link
 *
 * @generated from message cortado.v1.GenerateInvoicePortalLinkResponse
 */
export type GenerateInvoicePortalLinkResponse = Message<"cortado.v1.GenerateInvoicePortalLinkResponse"> & {
  /**
   * Full portal URL; short alias when enabled, legacy token query otherwise
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * JWT retained for wire compatibility; never embedded in short URLs
   *
   * @generated from field: string token = 2 [deprecated = true];
   * @deprecated
   */
  token: string;

  /**
   * When the token or short alias expires (30 days after issuance)
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePortalLinkResponse.
 * Use `create(GenerateInvoicePortalLinkResponseSchema)` to create a new message.
 */
export const GenerateInvoicePortalLinkResponseSchema: GenMessage<GenerateInvoicePortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 53);

/**
 * Dispute represents a Stripe dispute (chargeback) for a payment
 *
 * @generated from message cortado.v1.Dispute
 */
export type Dispute = Message<"cortado.v1.Dispute"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string stripe_charge_id = 3;
   */
  stripeChargeId: string;

  /**
   * Stripe dispute ID (dp_xxx)
   *
   * @generated from field: string dispute_id = 4;
   */
  disputeId: string;

  /**
   * @generated from field: cortado.v1.DisputeStatusEnum status = 5;
   */
  status: DisputeStatusEnum;

  /**
   * Dispute reason (e.g., "fraudulent", "product_not_received")
   *
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * Disputed amount in cents
   *
   * @generated from field: int64 amount_cents = 7;
   */
  amountCents: bigint;

  /**
   * Original payment amount for context
   *
   * @generated from field: int64 original_payment_cents = 8;
   */
  originalPaymentCents: bigint;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp closed_at = 11;
   */
  closedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp evidence_due_by = 12;
   */
  evidenceDueBy?: Timestamp;

  /**
   * Related entities (for linking to invoice/payment)
   *
   * @generated from field: optional string checkout_session_id = 20;
   */
  checkoutSessionId?: string;

  /**
   * @generated from field: optional string invoice_id = 21;
   */
  invoiceId?: string;

  /**
   * Denormalized contact info for display
   *
   * @generated from field: optional string contact_name = 30;
   */
  contactName?: string;

  /**
   * Payment method details for display
   *
   * @generated from field: optional string payment_method_brand = 40;
   */
  paymentMethodBrand?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 41;
   */
  paymentMethodLast4?: string;
};

/**
 * Describes the message cortado.v1.Dispute.
 * Use `create(DisputeSchema)` to create a new message.
 */
export const DisputeSchema: GenMessage<Dispute> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 54);

/**
 * ListDisputesRequest is used to list disputes for an organization
 *
 * @generated from message cortado.v1.ListDisputesRequest
 */
export type ListDisputesRequest = Message<"cortado.v1.ListDisputesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by dispute statuses
   *
   * @generated from field: repeated cortado.v1.DisputeStatusEnum statuses = 2;
   */
  statuses: DisputeStatusEnum[];

  /**
   * Optional flag to include closed disputes (WON, LOST, WARNING_CLOSED, CHARGE_REFUNDED)
   *
   * @generated from field: optional bool include_closed = 3;
   */
  includeClosed?: boolean;

  /**
   * Pagination
   *
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListDisputesRequest.
 * Use `create(ListDisputesRequestSchema)` to create a new message.
 */
export const ListDisputesRequestSchema: GenMessage<ListDisputesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 55);

/**
 * ListDisputesResponse contains disputes and summary counts
 *
 * @generated from message cortado.v1.ListDisputesResponse
 */
export type ListDisputesResponse = Message<"cortado.v1.ListDisputesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Dispute disputes = 1;
   */
  disputes: Dispute[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * Count of disputes requiring immediate action
   *
   * @generated from field: int32 needs_response_count = 3;
   */
  needsResponseCount: number;
};

/**
 * Describes the message cortado.v1.ListDisputesResponse.
 * Use `create(ListDisputesResponseSchema)` to create a new message.
 */
export const ListDisputesResponseSchema: GenMessage<ListDisputesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 56);

/**
 * @generated from enum cortado.v1.QuoteTemplateItemScalingType
 */
export enum QuoteTemplateItemScalingType {
  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_OVERAGE_HOUR = 2;
   */
  PER_OVERAGE_HOUR = 2,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_BARISTA_PER_HOUR = 3;
   */
  PER_BARISTA_PER_HOUR = 3,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_CART = 4;
   */
  PER_CART = 4,
}

/**
 * Describes the enum cortado.v1.QuoteTemplateItemScalingType.
 */
export const QuoteTemplateItemScalingTypeSchema: GenEnum<QuoteTemplateItemScalingType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_invoices, 0);

